import { createStyles, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const useKeyboardShortcutItemStyles = makeStyles((theme: ITheme) =>
  createStyles({
    action: {
      color: theme.palette.grey[400],
    },
    combination: {
      color: theme.palette.grey[400],
      fontWeight: 'bold',
    },
  })
);

const useShortcutHelperStyles = makeStyles(() => ({
  title: {
    paddingLeft: '2.5rem',
  },
}));

export { useKeyboardShortcutItemStyles, useShortcutHelperStyles };
